module.exports = "pegasus_template/assets/question-mark-icon.png";